import { useTranslation } from "react-i18next";
import { useSettingsStore } from "../../../../../features/settings/services/useSettingsStore";
import "./Slogan.css";

export function Slogan() {
  const settingsStore = useSettingsStore();
  const { i18n } = useTranslation();

  const slogan1 = (settingsStore.clientConfiguration?.slogan1 ?? "").split("|")[
    i18n.language === "en" ? 1 : 0
  ];
  const slogan2 = (settingsStore.clientConfiguration?.slogan2 ?? "").split("|")[
    i18n.language === "en" ? 1 : 0
  ];

  return (
    <div className="slogan hidden md:flex mb-2">
      <div className="slogan-row-0"></div>
      <div className="slogan-row-1 flex align-items-center justify-content-center gap-1">
        <span className="slogan1">{slogan1}</span>
        <span>{slogan2}</span>
      </div>
      <div className="slogan-row-2"></div>
    </div>
  );
}
